import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SchoolIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M19 18.19 12 22l-7-3.81V13l7 3.81L19 13z" /><path d="M23 9v8h-2v-6.9L12 15 1 9l11-6z" />
    </SvgIcon>
);
